import {
  BasePageMetaResolver, PageRobotsMeta, ProductSearchService, RoutingService, SearchPageMetaResolver, TranslationService
} from '@spartacus/core'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { MbPageMetaLinkService } from '../../cms/page/mb-page-meta-link.service'
import { MbBasePageMetaResolver } from '../../cms/page/mb-base-page-meta-resolver'
import { CountryService } from '../../site-context/facade/country.service'
import { switchMap } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class MiltenyiSearchPageMetaResolver extends SearchPageMetaResolver {

  constructor (routingService: RoutingService,
               productSearchService: ProductSearchService,
               translation: TranslationService,
               basePageMetaResolver: BasePageMetaResolver,
               private mbPageMetaLinkService: MbPageMetaLinkService,
               private mbBasePageMetaResolver: MbBasePageMetaResolver,
               private countryService: CountryService) {
    super(routingService, productSearchService, translation, basePageMetaResolver)
  }

  resolveHrefLang (): Observable<boolean> {
    return this.mbPageMetaLinkService.setHrefLang()
  }

  resolveCanonicalUrl (): Observable<any> {
    return this.mbPageMetaLinkService.setCanonicalUrl()
  }

  resolveRobots (): Observable<PageRobotsMeta[]> {
    return this.mbBasePageMetaResolver.resolveRobots()
  }

  resolveTitle (): Observable<string> {
    return this.countryService.getActiveCountryNameInNatLang().pipe(
      switchMap((activeName: string) =>
        this.translation.translate('pageMetaResolver.search.mbTitle', { countryName: activeName })
      )
    )
  }

  resolveDescription (): Observable<string> {
    return this.translation.translate('pageMetaResolver.search.description')
  }
}
